import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from '../routeGenerator';

export const naturalGasRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_NATURAL_GAS.USAGE}
      />
    ),
    name: 'Aggregated Usage',
    path: NESTED_ROUTES.INTERVAL_DATA_NATURAL_GAS.USAGE,
    description: 'Analyze natural gas usage by selectable time periods',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_NATURAL_GAS.MAP}
      />
    ),
    name: 'Usage Map',
    path: NESTED_ROUTES.INTERVAL_DATA_NATURAL_GAS.MAP,
    description: 'Review natural gas usage by site location',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_NATURAL_GAS.HEATMAP}
      />
    ),
    name: 'Natural Gas Heatmap',
    path: NESTED_ROUTES.INTERVAL_DATA_NATURAL_GAS.HEATMAP,
    description: 'Analyze natural gas usage over time',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_NATURAL_GAS.POINTS}
      />
    ),
    name: 'All Natural Gas Points',
    path: NESTED_ROUTES.INTERVAL_DATA_NATURAL_GAS.POINTS,
    description: 'Analyze trends for all available natural gas points',
  },
];
